var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappyAsset41(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 28,
    viewBox: "0 0 48 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "happyAsset 4 1",
    clipPath: "url(#clip0_5253_12980)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2_2"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M44.3131 12.2693C44.1115 11.0889 43.7314 9.94398 43.1849 8.87191C42.9096 8.33712 42.5928 7.82353 42.2372 7.33562C42.0589 7.09421 41.8672 6.85718 41.6663 6.62893C41.4646 6.40018 41.2483 6.18395 41.0188 5.98149L40.8224 5.8125L40.2087 6.5148L40.4186 6.65088C40.8049 7.03709 41.1496 7.46067 41.4475 7.91502C41.7573 8.37307 42.0304 8.85367 42.2643 9.35255C42.7328 10.3547 43.0454 11.4191 43.1917 12.5107C43.3444 13.5961 43.3505 14.6962 43.2097 15.783C43.078 16.8554 42.7678 17.8998 42.2914 18.8754C41.8083 19.8557 41.1871 20.7658 40.4456 21.5792C39.7031 22.4015 38.8657 23.1379 37.9501 23.7739C37.495 24.0932 37.0211 24.3863 36.5308 24.6518C36.2804 24.7879 36.0322 24.913 35.7907 25.0227C35.5469 25.1344 35.2968 25.2326 35.0416 25.3168C34.9717 25.3388 34.9175 25.3519 34.8679 25.3629C34.8307 25.3723 34.7931 25.3797 34.755 25.3848L34.6783 25.4002L34.2496 25.4792L33.3922 25.6482C32.8123 25.7645 32.2392 25.8874 31.6864 26.0103L31.208 26.1157L31.5194 27.4325L31.9977 27.3272C32.5506 27.2064 33.144 27.077 33.7397 26.9541L34.6106 26.7807L35.0461 26.6995C35.2169 26.6676 35.3851 26.6236 35.5493 26.5678C36.1387 26.3577 36.708 26.0978 37.2506 25.7909C37.7892 25.49 38.3098 25.1595 38.8098 24.8011C39.8062 24.0937 40.7149 23.2762 41.5174 22.3649C42.3261 21.4498 42.9949 20.4261 43.503 19.3253C44.0117 18.2218 44.3296 17.0443 44.4439 15.8401C44.5622 14.6494 44.5182 13.4488 44.3131 12.2693ZM43.943 15.8028C43.8324 16.9561 43.5275 18.0839 43.0405 19.1409C42.5519 20.1993 41.9081 21.1833 41.1293 22.0621C40.3525 22.9456 39.4727 23.7381 38.5074 24.4236C38.0257 24.7658 37.5248 25.0816 37.0069 25.3695C36.4899 25.6618 35.9479 25.91 35.3868 26.1113C35.2451 26.1584 35.1004 26.1965 34.9536 26.2254L34.5136 26.3066C34.2361 26.3593 33.9495 26.4164 33.6359 26.4822C33.0379 26.6051 32.4423 26.7346 31.8872 26.8575L31.7947 26.469C32.3452 26.3483 32.9229 26.2276 33.4892 26.1113C33.7735 26.052 34.0556 25.9972 34.3399 25.9423L34.7686 25.8633L34.8408 25.8501L34.9807 25.8238C35.0393 25.8106 35.1048 25.7909 35.1905 25.7645C35.4654 25.6753 35.7344 25.5698 35.996 25.4485C36.2488 25.3366 36.5083 25.2049 36.77 25.0644C38.2907 24.2375 39.6576 23.1676 40.8134 21.8997C41.5851 21.0526 42.2314 20.1048 42.7336 19.0839C43.2346 18.0581 43.5593 16.9593 43.6948 15.8313C43.8413 14.7037 43.8352 13.5622 43.6768 12.4361C43.4434 10.73 42.8179 9.09701 41.8468 7.65824C41.822 7.62313 41.7972 7.58801 41.7746 7.5529C41.7904 7.57484 41.8085 7.59679 41.8243 7.62093C42.1632 8.08721 42.465 8.57807 42.7268 9.08919C43.254 10.1188 43.622 11.2185 43.8189 12.3527C44.0168 13.4923 44.0585 14.6525 43.943 15.8028Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M44.0716 12.307C43.8689 11.1501 43.4926 10.0283 42.9547 8.97767C42.6855 8.45495 42.3755 7.95308 42.0274 7.47649C41.8536 7.23947 41.6663 7.00902 41.47 6.78955C41.2742 6.56815 41.0639 6.35923 40.8405 6.16406L40.5743 6.46693C40.5743 6.46693 40.6036 6.49327 40.6397 6.52838L40.572 6.46474C40.975 6.86767 41.3356 7.30881 41.6483 7.78156C41.965 8.25051 42.2448 8.74206 42.4854 9.25201C42.9619 10.2721 43.282 11.3546 43.4353 12.465C43.5918 13.5714 43.5979 14.6931 43.4534 15.801C43.3192 16.9041 43.0022 17.9788 42.5147 18.9833C42.0208 19.9832 41.3868 20.9116 40.6307 21.7421C39.4933 22.9903 38.1477 24.0432 36.6504 24.8563C36.4022 24.9902 36.1495 25.1175 35.8945 25.2338C35.6414 25.3496 35.3815 25.4508 35.1161 25.5367C35.0529 25.5564 34.9875 25.5762 34.9265 25.5894C34.8656 25.6025 34.7957 25.6135 34.7235 25.6289L34.297 25.7079C34.0104 25.7627 33.7261 25.8176 33.4418 25.8769C32.8732 25.991 32.3136 26.1117 31.7405 26.2368L31.5013 26.2895L31.5578 26.5243L31.6503 26.9128L31.7044 27.1322L31.9436 27.0796C32.5235 26.9523 33.1056 26.825 33.69 26.7043L34.5655 26.5309L35.0032 26.4497C35.161 26.4196 35.3164 26.3786 35.4681 26.3268C36.0433 26.1211 36.5989 25.867 37.1288 25.5674C37.6561 25.2751 38.1661 24.9542 38.6563 24.6061C39.6368 23.9101 40.5304 23.105 41.3189 22.2073C42.1121 21.3098 42.7687 20.3061 43.2684 19.2269C43.7632 18.1453 44.0742 16.9927 44.189 15.8142C44.3085 14.6452 44.2691 13.466 44.0716 12.307Z",
    fill: "url(#paint0_linear_5253_12980)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M35.9713 26.7612C35.9378 26.7127 35.9077 26.6621 35.881 26.6098L35.8381 26.5308L35.8607 26.4452C35.8742 26.3837 36.2533 24.9462 38.4555 24.2724C40.6578 23.5986 42.6186 24.8211 42.702 24.8738L42.9277 25.0186L42.7585 25.2249C42.1188 25.9729 41.3564 26.6129 40.5021 27.1189C38.6496 28.1834 36.6662 27.7927 35.9713 26.7612ZM36.3661 26.4737L36.3819 26.4978C36.9415 27.3274 38.6654 27.6171 40.2471 26.7173C40.9673 26.2892 41.6201 25.7622 42.1853 25.1525C41.61 24.8672 40.1365 24.2746 38.6022 24.7399C36.9528 25.2403 36.4767 26.184 36.3661 26.4737Z",
    fill: "#424242"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M36.1021 26.4984C36.1021 26.4984 36.4361 25.1399 38.53 24.4991C40.6239 23.8582 42.5712 25.0741 42.5712 25.0741C41.9464 25.798 41.2049 26.4184 40.3757 26.911C38.6405 27.9074 36.6594 27.5629 36.1021 26.4984Z",
    fill: "url(#paint1_linear_5253_12980)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3117 25.0722C42.3117 25.0722 39.9854 24.0429 38.3653 24.8659C36.7452 25.6889 37.7583 27.2449 38.9 27.1659C40.0418 27.0869 42.4403 25.2719 42.3117 25.0722Z",
    fill: "#F7F7F7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0838 25.1553C42.0838 25.1553 40.4524 26.4919 39.6807 26.3844C38.9091 26.2768 38.7173 25.219 39.4393 24.7757C40.1613 24.3323 42.0838 25.1553 42.0838 25.1553Z",
    fill: "#F7F7F7"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M40.8405 23.0437C40.7977 23.002 40.7571 22.9581 40.7187 22.9143L40.66 22.844V22.7562C40.66 22.6948 40.7187 21.2199 42.7246 20.0985C44.7305 18.977 46.9125 19.7802 47.0118 19.8131L47.2667 19.9053L47.1584 20.1445C46.692 21.0085 46.0821 21.7916 45.3533 22.4621C43.7738 23.8821 41.7431 23.9216 40.8405 23.0437ZM41.1632 22.6794C41.1702 22.6873 41.1777 22.6946 41.1858 22.7014C41.9123 23.3971 43.6678 23.3247 45.0081 22.1088C45.6208 21.5459 46.1467 20.8998 46.5695 20.1906C45.9467 20.0304 44.374 19.7517 42.9796 20.5264C41.4768 21.3494 41.2174 22.3853 41.1722 22.6816L41.1632 22.6794Z",
    fill: "#424242"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M40.9172 22.7657C40.9172 22.7657 40.9511 21.3677 42.8577 20.3098C44.7644 19.252 46.9327 20.0399 46.9327 20.0399C46.4801 20.8764 45.8902 21.6355 45.1863 22.2873C43.7084 23.6194 41.6957 23.6897 40.9172 22.7657Z",
    fill: "url(#paint2_linear_5253_12980)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_9",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.68 20.0864C46.68 20.0864 44.18 19.5597 42.7765 20.6988C41.373 21.8378 42.702 23.1481 43.8009 22.8364C44.8998 22.5248 46.847 20.2554 46.68 20.0864Z",
    fill: "#F7F7F7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_10",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4815 20.2212C46.4815 20.2212 45.1773 21.8629 44.4011 21.9156C43.6249 21.9682 43.2052 20.9762 43.8144 20.3946C44.4236 19.813 46.4815 20.2212 46.4815 20.2212Z",
    fill: "#F7F7F7"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M44.356 17.4548C44.3052 17.4413 44.2555 17.4244 44.2071 17.4043L44.1326 17.3736L44.0965 17.3056C44.0694 17.2551 43.4782 16.0831 44.5478 14.4086C45.6173 12.734 47.6593 12.4619 47.7451 12.4487L47.982 12.418V12.6506C48.0009 13.5068 47.8752 14.3602 47.6097 15.1767C46.9847 16.9171 45.4278 17.7599 44.356 17.4548ZM44.453 17.0422H44.4778C45.3398 17.2858 46.6643 16.5221 47.1855 15.0319C47.4148 14.3449 47.541 13.6294 47.56 12.9074C47.0095 13.0347 45.6715 13.4561 44.9201 14.6236C44.1145 15.8878 44.356 16.7876 44.4507 17.0422H44.453Z",
    fill: "#424242"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M44.2883 17.2081C44.2883 17.2081 43.7152 16.1107 44.7396 14.5196C45.764 12.9284 47.7812 12.6562 47.7812 12.6562C47.7866 13.489 47.6524 14.317 47.3841 15.1077C46.82 16.7384 45.2901 17.6097 44.2883 17.2081Z",
    fill: "url(#paint3_linear_5253_12980)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_13",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6097 12.7969C47.6097 12.7969 45.4481 13.4026 44.8479 14.8533C44.2477 16.304 45.8384 16.7825 46.556 16.0955C47.2735 15.4086 47.8105 12.8583 47.6097 12.7969Z",
    fill: "#F7F7F7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_14",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5059 12.9805C47.5059 12.9805 47.199 14.7823 46.6192 15.1401C46.0393 15.4978 45.2879 14.8942 45.5113 14.1963C45.7346 13.4984 47.5059 12.9805 47.5059 12.9805Z",
    fill: "#F7F7F7"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M44.3447 12.3403C44.2925 12.3494 44.2397 12.3553 44.1867 12.3579H44.1055L44.0423 12.3096C43.9972 12.2767 42.9322 11.4822 43.1398 9.51572C43.3474 7.54926 45.0396 6.42777 45.1096 6.38168L45.3082 6.25L45.4232 6.45411C45.8226 7.21944 46.0909 8.04303 46.2175 8.89242C46.4544 10.7228 45.4435 12.1494 44.3447 12.3403ZM44.2431 11.9277H44.268C45.1525 11.7741 45.9896 10.5165 45.7797 8.95607C45.6713 8.24122 45.4586 7.54507 45.148 6.88866C44.7125 7.24201 43.7039 8.20548 43.5685 9.56619C43.4128 11.0388 44.0401 11.7411 44.2431 11.9277Z",
    fill: "#424242"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M44.1709 12.1441C44.1709 12.1441 43.1578 11.4111 43.3474 9.54119C43.5369 7.67131 45.2247 6.55859 45.2247 6.55859C45.611 7.30077 45.8709 8.09906 45.9941 8.92229C46.2242 10.632 45.2517 12.0695 44.1709 12.1441Z",
    fill: "url(#paint4_linear_5253_12980)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_17",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1276 6.75809C45.1276 6.75809 43.4647 8.23513 43.5888 9.79556C43.7129 11.356 45.3578 11.0948 45.6872 10.1709C46.0166 9.24688 45.3533 6.72737 45.1276 6.75809Z",
    fill: "#F7F7F7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_18",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1277 6.96875C45.1277 6.96875 45.676 8.72451 45.3195 9.28855C44.9629 9.85259 44.0153 9.6419 43.8957 8.92203C43.7761 8.20217 45.1277 6.96875 45.1277 6.96875Z",
    fill: "#F7F7F7"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M35.3304 26.0835C35.2703 26.0868 35.21 26.0868 35.1499 26.0835H35.0597L34.9942 26.022C34.9468 25.9781 33.866 24.9247 34.3827 22.7453C34.8995 20.566 36.9798 19.5323 37.0678 19.4818L37.3093 19.3633L37.4085 19.6091C37.7444 20.5256 37.9243 21.4893 37.9411 22.4622C37.9478 24.5559 36.5962 26.0242 35.3304 26.0835ZM35.2763 25.605H35.3056C36.3255 25.5567 37.4559 24.2575 37.4492 22.4688C37.4345 21.6492 37.2977 20.836 37.043 20.0546C36.4992 20.3904 35.2221 21.3253 34.8611 22.8485C34.4752 24.4857 35.0754 25.368 35.2763 25.605Z",
    fill: "#424242"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M35.1635 25.8466C35.1635 25.8466 34.1301 24.8765 34.6219 22.7959C35.1138 20.7154 37.1784 19.6992 37.1784 19.6992C37.5039 20.5899 37.6784 21.526 37.6951 22.4711C37.7019 24.4288 36.391 25.9168 35.1635 25.8466Z",
    fill: "url(#paint5_linear_5253_12980)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_21",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0453 19.9102C37.0453 19.9102 34.9536 21.3389 34.8633 23.1144C34.7731 24.8899 36.6685 24.8285 37.1716 23.8321C37.6748 22.8357 37.2867 19.9036 37.0453 19.9102Z",
    fill: "#F7F7F7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_22",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0047 20.1445C37.0047 20.1445 37.3635 22.19 36.8783 22.7782C36.3932 23.3664 35.3553 22.9976 35.3282 22.168C35.3011 21.3384 37.0047 20.1445 37.0047 20.1445Z",
    fill: "#F7F7F7"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M40.7344 22.2889C40.6835 22.3197 40.6308 22.3475 40.5765 22.3723L40.4953 22.4118L40.4073 22.3877C40.3441 22.3723 38.8774 21.9663 38.2411 19.8089C37.6048 17.6515 38.9181 15.775 38.9722 15.696L39.1234 15.4766L39.3332 15.6456C40.0847 16.2902 40.7226 17.0501 41.2218 17.8951C42.2665 19.7211 41.813 21.6415 40.7344 22.2889ZM40.4501 21.8961C40.4592 21.8923 40.4676 21.8871 40.475 21.8807C41.3437 21.3606 41.6866 19.686 40.7909 18.1278C40.3688 17.418 39.8446 16.7705 39.234 16.2052C38.9248 16.7539 38.2727 18.1804 38.715 19.6772C39.1911 21.2881 40.1636 21.7819 40.4501 21.8961Z",
    fill: "#424242"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M40.4705 22.1672C40.4705 22.1672 39.0828 21.805 38.4781 19.753C37.8734 17.701 39.1753 15.8398 39.1753 15.8398C39.9042 16.4695 40.5223 17.2109 41.0052 18.0345C41.9845 19.7223 41.5784 21.6426 40.4705 22.1672Z",
    fill: "url(#paint6_linear_5253_12980)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_25",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1641 16.0785C39.1641 16.0785 38.0359 18.3149 38.8504 19.9104C39.665 21.506 41.2783 20.5689 41.2264 19.4518C41.1745 18.3346 39.3717 15.96 39.1641 16.0785Z",
    fill: "#F7F7F7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_26",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2453 16.3008C39.2453 16.3008 40.5765 17.9227 40.4457 18.6711C40.3148 19.4195 39.2227 19.5775 38.7872 18.8642C38.3518 18.1509 39.2453 16.3008 39.2453 16.3008Z",
    fill: "#F7F7F7"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M43.5866 12.263C43.564 12.3091 43.5414 12.3574 43.5144 12.4013L43.476 12.4693L43.4016 12.4957C43.3474 12.5154 42.0793 12.9346 40.4976 11.7078C38.9159 10.4809 38.882 8.47058 38.8798 8.38498V8.15234L39.1189 8.1721C39.9951 8.26612 40.8495 8.4989 41.6483 8.86123C43.3497 9.65791 44.0243 11.2644 43.5866 12.263ZM43.1759 12.1204C43.1801 12.1125 43.1839 12.1045 43.1872 12.0962C43.5392 11.2952 42.9164 9.92347 41.4588 9.24311C40.7845 8.93926 40.0686 8.73155 39.3333 8.6264C39.3987 9.17507 39.6695 10.5182 40.7706 11.3807C41.9552 12.3069 42.9051 12.184 43.1759 12.1204Z",
    fill: "#424242"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M43.3226 12.2903C43.3226 12.2903 42.1357 12.7139 40.6307 11.5354C39.1257 10.3568 39.0919 8.375 39.0919 8.375C39.9428 8.46709 40.7727 8.69317 41.5491 9.04438C43.1488 9.79717 43.8551 11.3795 43.3226 12.2903Z",
    fill: "url(#paint7_linear_5253_12980)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_29",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2182 8.56087C39.2182 8.56087 39.5792 10.7227 40.9895 11.4732C42.3997 12.2238 43.0766 10.7468 42.4606 9.97207C41.8446 9.19734 39.3062 8.37871 39.2182 8.56087Z",
    fill: "#F7F7F7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_30",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3942 8.6875C39.3942 8.6875 41.1993 9.19887 41.4926 9.80021C41.7859 10.4016 41.0842 11.0578 40.3892 10.7549C39.6943 10.452 39.3942 8.6875 39.3942 8.6875Z",
    fill: "#F7F7F7"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M42.059 7.11458C42.0393 7.16234 42.0159 7.20856 41.989 7.25285L41.9507 7.32088L41.8762 7.34722C41.8221 7.36697 40.554 7.79713 38.9723 6.55932C37.3905 5.32151 37.3567 3.32214 37.3544 3.23654V3.00391L37.5936 3.02366C38.4705 3.11729 39.3258 3.35009 40.1253 3.71279C41.8243 4.51167 42.499 6.11599 42.059 7.11458ZM41.6506 6.97193C41.651 6.96388 41.651 6.95583 41.6506 6.94778C42.0026 6.14672 41.3798 4.77503 39.9222 4.09467C39.2478 3.79082 38.532 3.58311 37.7967 3.47796C37.8621 4.02664 38.1329 5.36979 39.234 6.23231C40.4299 7.15848 41.3776 7.03557 41.6506 6.97193Z",
    fill: "#424242"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M41.8018 7.14972C41.8018 7.14972 40.6126 7.5733 39.1099 6.39474C37.6071 5.21619 37.571 3.23438 37.571 3.23438C38.4205 3.32357 39.2496 3.54591 40.026 3.89279C41.6235 4.64996 42.3298 6.23234 41.8018 7.14972Z",
    fill: "url(#paint8_linear_5253_12980)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_33",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6929 3.4179C37.6929 3.4179 38.0539 5.57968 39.4641 6.33027C40.8744 7.08086 41.5513 5.60383 40.9353 4.8291C40.3193 4.05437 37.7809 3.22916 37.6929 3.4179Z",
    fill: "#F7F7F7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_34",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8689 3.53906C37.8689 3.53906 39.674 4.05043 39.9673 4.65178C40.2607 5.25312 39.5589 5.90934 38.873 5.61086C38.187 5.31238 37.8689 3.53906 37.8689 3.53906Z",
    fill: "#F7F7F7"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M43.6114 17.5772C43.5816 17.6193 43.5492 17.6596 43.5144 17.6979L43.4602 17.7572H43.3812C43.3271 17.7572 41.9936 17.9349 40.7052 16.4074C39.4168 14.8799 39.8026 12.9201 39.8184 12.8367L39.8635 12.6172L40.0892 12.683C40.9273 12.9488 41.7148 13.347 42.42 13.8616C43.9273 14.9809 44.2499 16.6818 43.6114 17.5772ZM43.2413 17.3577L43.2549 17.3358C43.7693 16.6203 43.4467 15.1543 42.1628 14.1952C41.5668 13.7645 40.9102 13.4193 40.2133 13.1703C40.1614 13.7189 40.1433 15.0884 41.0414 16.1529C42.0071 17.2963 42.9615 17.3643 43.2413 17.3577Z",
    fill: "#424242"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M43.3496 17.5592C43.3496 17.5592 42.0996 17.7392 40.8676 16.2863C39.6356 14.8334 40.026 12.8867 40.026 12.8867C40.8363 13.1465 41.5983 13.5319 42.2823 14.028C43.6993 15.077 44.0604 16.767 43.3496 17.5592Z",
    fill: "url(#paint9_linear_5253_12980)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_37",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1117 13.0887C40.1117 13.0887 40.0124 15.2834 41.2399 16.293C42.4674 17.3025 43.4376 15.9945 42.9976 15.1144C42.5576 14.2343 40.2381 12.9219 40.1117 13.0887Z",
    fill: "#F7F7F7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_38",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2584 13.2422C40.2584 13.2422 41.9168 14.1003 42.0793 14.7478C42.2418 15.3952 41.4159 15.8978 40.8067 15.4698C40.1975 15.0418 40.2584 13.2422 40.2584 13.2422Z",
    fill: "#F7F7F7"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M3.56508 15.8469C3.68271 17.0513 4.00286 18.2287 4.51276 19.3321C5.02178 20.433 5.69129 21.4567 6.50063 22.3718C7.30309 23.2831 8.21174 24.1007 9.20829 24.8079C9.70677 25.1611 10.225 25.4872 10.7607 25.7845C11.2996 26.0898 11.8652 26.3483 12.4507 26.5571C12.6149 26.6129 12.7831 26.6569 12.9539 26.6888L13.3894 26.77C13.6646 26.8226 13.9489 26.8797 14.2581 26.9433C14.856 27.0662 15.4494 27.1957 16.0023 27.3164L16.4716 27.435L16.783 26.1181L16.3046 26.0128C15.7518 25.8899 15.1764 25.767 14.5988 25.6507L13.7414 25.4817L13.3126 25.4027L13.2359 25.3873C13.1979 25.3823 13.1602 25.375 13.1231 25.3654C13.0735 25.3654 13.0193 25.3412 12.9471 25.3193C12.6958 25.2329 12.4495 25.1333 12.2093 25.0208C11.9678 24.9111 11.7174 24.786 11.4669 24.6499C9.99529 23.8457 8.67276 22.8071 7.55436 21.5773C6.81307 20.7645 6.19185 19.8552 5.70864 18.8756C5.23077 17.896 4.92057 16.847 4.7903 15.7701C4.64957 14.6877 4.65564 13.5919 4.80835 12.511C4.95931 11.4244 5.27408 10.3655 5.74249 9.36818C5.97803 8.86969 6.25183 8.38915 6.56156 7.93065C6.85939 7.4763 7.20414 7.05271 7.59047 6.6665L7.79805 6.53043L7.18432 5.82812L6.99027 5.99712C6.76017 6.19901 6.54385 6.41528 6.34269 6.64455C6.14187 6.86402 5.95008 7.10983 5.77182 7.35125C5.41541 7.83864 5.09856 8.35229 4.82414 8.88754C4.27628 9.9546 3.89236 11.0941 3.68467 12.2696C3.48382 13.4518 3.44361 14.6545 3.56508 15.8469ZM4.16979 12.3508C4.36852 11.2167 4.73723 10.1172 5.26414 9.08726C5.52599 8.57614 5.82773 8.08528 6.16669 7.619C6.18248 7.59486 6.20053 7.57291 6.21633 7.55097L6.14413 7.65631C5.82066 8.13507 5.53479 8.63689 5.28896 9.15749C4.80054 10.1973 4.4721 11.3013 4.3142 12.4342C4.15504 13.5602 4.14821 14.7016 4.29389 15.8294C4.43152 16.957 4.75614 18.0554 5.25511 19.0819C5.75884 20.102 6.405 21.0496 7.17529 21.8977C8.33105 23.1667 9.69885 24.2366 11.221 25.0625C11.4827 25.2029 11.7422 25.3346 11.9949 25.4466C12.2565 25.5678 12.5255 25.6734 12.8005 25.7626C12.8839 25.7889 12.9516 25.8087 13.0103 25.8219L13.1502 25.8482L13.2224 25.8614L13.6511 25.9404C13.9332 25.9952 14.2175 26.0501 14.4995 26.1094C15.0749 26.2257 15.6457 26.3464 16.194 26.4671L16.1038 26.8556C15.5487 26.7327 14.953 26.6032 14.3528 26.4803C14.0415 26.4144 13.7549 26.3574 13.4751 26.3047L13.0374 26.2235C12.8906 26.1946 12.7459 26.1565 12.6041 26.1094C12.0431 25.9081 11.501 25.6599 10.9841 25.3675C10.4658 25.0791 9.96412 24.7634 9.48131 24.4216C8.51678 23.7361 7.63763 22.9436 6.86165 22.0601C6.0876 21.1805 5.44844 20.1966 4.96404 19.139C4.47628 18.083 4.17132 16.9558 4.06148 15.803C3.9416 14.6527 3.97802 13.4919 4.16979 12.3508Z",
    fill: "#424242"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M3.92839 12.307C4.1301 11.1498 4.50646 10.0279 5.0453 8.97767C5.31364 8.45449 5.62371 7.95256 5.97267 7.47649C6.14641 7.23947 6.33369 7.00902 6.52774 6.78955C6.72292 6.56827 6.93243 6.35934 7.15502 6.16406L7.42127 6.46693L7.35583 6.52838L7.42353 6.46474C7.01985 6.8671 6.65923 7.30831 6.34723 7.78156C6.03053 8.25051 5.7507 8.74206 5.51011 9.25201C5.03545 10.2726 4.71621 11.3549 4.56243 12.4651C4.40674 13.5715 4.40143 14.6932 4.54664 15.801C4.67972 16.9043 4.99676 17.9792 5.48529 18.9833C5.97837 19.9836 6.61251 20.9122 7.36937 21.7421C8.12512 22.5732 8.97603 23.3177 9.90555 23.9609C10.3681 24.2847 10.8495 24.5822 11.3474 24.8519C11.5956 24.9858 11.8483 25.1131 12.1055 25.2294C12.3579 25.3452 12.617 25.4464 12.8817 25.5323C12.9471 25.5521 13.0126 25.5718 13.0735 25.585C13.1344 25.5981 13.2044 25.6091 13.2743 25.6245L13.703 25.7035C13.9896 25.7584 14.2739 25.8132 14.5582 25.8725C15.1268 25.9866 15.6864 26.1073 16.2595 26.2324L16.4852 26.2851L16.431 26.5199L16.3385 26.9084L16.2843 27.1279L16.0452 27.0752C15.463 26.9479 14.8809 26.8206 14.2987 26.6999L13.4232 26.5265L12.9855 26.4453C12.8277 26.4153 12.6724 26.3742 12.5207 26.3224C11.9451 26.1176 11.3894 25.8634 10.86 25.563C10.3327 25.2707 9.82269 24.9498 9.33242 24.6017C8.35191 23.9057 7.45835 23.1007 6.66989 22.2029C5.88318 21.3082 5.23271 20.3082 4.73843 19.2335C4.24254 18.1523 3.93158 16.9995 3.81783 15.8207C3.69545 14.6499 3.73263 13.4684 3.92839 12.307Z",
    fill: "url(#paint10_linear_5253_12980)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M7.50026 27.1163C6.64613 26.61 5.88376 25.9701 5.24387 25.2223L5.07465 25.016L5.30028 24.8711C5.38377 24.8185 7.36939 23.6026 9.54679 24.2698C11.7242 24.937 12.1281 26.3811 12.1416 26.4425L12.1642 26.5281L12.1213 26.6072C12.0942 26.6576 12.0649 26.7081 12.0311 26.7586C11.3338 27.7901 9.35049 28.1808 7.50026 27.1163ZM9.39787 24.7263C7.86353 24.2566 6.38786 24.8536 5.81474 25.1389C6.37995 25.7486 7.03278 26.2756 7.75297 26.7037C9.33244 27.6145 11.0586 27.3248 11.6182 26.4842L11.6339 26.4601C11.5234 26.1814 11.0563 25.2377 9.39787 24.7263Z",
    fill: "#424242"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M11.9002 26.4984C11.9002 26.4984 11.564 25.1399 9.47233 24.4991C7.38067 23.8582 5.43115 25.0741 5.43115 25.0741C6.05589 25.798 6.79737 26.4184 7.62661 26.911C9.35951 27.9074 11.3406 27.5629 11.9002 26.4984Z",
    fill: "url(#paint11_linear_5253_12980)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_43",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68838 25.0722C5.68838 25.0722 8.01471 24.0429 9.63254 24.8659C11.2504 25.6889 10.2418 27.2449 9.10003 27.1659C7.9583 27.0869 5.55977 25.2719 5.68838 25.0722Z",
    fill: "#F7F7F7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_44",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M5.914 25.1553C5.914 25.1553 7.54536 26.4919 8.3193 26.3844C9.09324 26.2768 9.28278 25.219 8.56074 24.7757C7.83869 24.3323 5.914 25.1553 5.914 25.1553Z",
    fill: "#F7F7F7"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M2.64674 22.4632C1.91824 21.7924 1.30837 21.0093 0.841634 20.1456L0.722046 19.9086L0.977017 19.8164C1.06953 19.7835 3.27401 19 5.26414 20.1017C7.25427 21.2034 7.32647 22.698 7.32873 22.7595V22.8473L7.27007 22.9175C7.23171 22.9614 7.19109 23.0053 7.14822 23.047C6.24792 23.9227 4.22169 23.8832 2.64674 22.4632ZM5.02045 20.5187C3.62601 19.7527 2.05331 20.0227 1.43055 20.1917C1.84963 20.9042 2.37252 21.554 2.98294 22.1208C4.33677 23.3367 6.0787 23.4091 6.80525 22.7134L6.82556 22.6914C6.78269 22.3864 6.5232 21.3505 5.02045 20.5187Z",
    fill: "#424242"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M7.08053 22.7657C7.08053 22.7657 7.04894 21.3677 5.1423 20.3098C3.23565 19.252 1.08081 20.0399 1.08081 20.0399C1.53308 20.876 2.12217 21.6351 2.82499 22.2873C4.28713 23.6194 6.30208 23.6897 7.08053 22.7657Z",
    fill: "url(#paint12_linear_5253_12980)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_47",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1.32002 20.0864C1.32002 20.0864 3.82009 19.5597 5.2213 20.6988C6.62251 21.8378 5.29802 23.1481 4.19916 22.8364C3.1003 22.5248 1.15304 20.2554 1.32002 20.0864Z",
    fill: "#F7F7F7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_48",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1.52307 20.2212C1.52307 20.2212 2.82726 21.8629 3.60571 21.9156C4.38416 21.9682 4.80159 20.9762 4.19237 20.3946C3.58315 19.813 1.52307 20.2212 1.52307 20.2212Z",
    fill: "#F7F7F7"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M0.401673 15.1767C0.126252 14.3618 -0.00943928 13.5084 3.68783e-05 12.6506V12.418L0.236957 12.4487C0.324956 12.4619 2.36924 12.7494 3.43425 14.4086C4.49926 16.0678 3.92163 17.2617 3.88552 17.3056L3.84942 17.3736L3.77496 17.4043C3.72655 17.4244 3.6768 17.4413 3.62604 17.4548C2.57231 17.7599 1.01541 16.9171 0.401673 15.1767ZM3.07774 14.6324C2.32637 13.4648 0.988332 13.0435 0.435518 12.9162C0.456763 13.6381 0.583643 14.3535 0.812334 15.0406C1.33581 16.5308 2.66031 17.2946 3.51999 17.051H3.54481C3.64409 16.7876 3.88327 15.8878 3.07774 14.6324Z",
    fill: "#424242"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M3.7118 17.2081C3.7118 17.2081 4.28492 16.1107 3.26052 14.5196C2.23613 12.9284 0.22569 12.6562 0.22569 12.6562C0.2152 13.4881 0.343994 14.3161 0.607019 15.1077C1.18014 16.7384 2.70771 17.6097 3.7118 17.2081Z",
    fill: "url(#paint13_linear_5253_12980)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_51",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M0.390356 12.7969C0.390356 12.7969 2.55423 13.4026 3.15894 14.8533C3.76365 16.304 2.16387 16.7825 1.44409 16.0955C0.7243 15.4086 0.189538 12.8583 0.390356 12.7969Z",
    fill: "#F7F7F7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_52",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0.494202 12.9805C0.494202 12.9805 0.801069 14.7823 1.38096 15.1422C1.96085 15.5022 2.70771 14.8942 2.48207 14.1963C2.25644 13.4984 0.494202 12.9805 0.494202 12.9805Z",
    fill: "#F7F7F7"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M1.78933 8.89633C1.91593 8.04694 2.1842 7.22334 2.58357 6.45801L2.69639 6.25391L2.89496 6.38559C2.96716 6.43168 4.66847 7.57292 4.86703 9.51962C5.06559 11.4663 4.00284 12.2806 3.96448 12.3135L3.89904 12.3618H3.82007C3.76709 12.3592 3.71434 12.3533 3.66212 12.3442C2.5565 12.1467 1.54564 10.7201 1.78933 8.89633ZM4.43606 9.55474C4.29617 8.18524 3.28757 7.23055 2.8566 6.8772C2.54495 7.53323 2.33217 8.22952 2.22481 8.94461C2.01497 10.505 2.85208 11.7626 3.73659 11.9162H3.76141C3.95997 11.7385 4.58724 11.0362 4.43606 9.56132V9.55474Z",
    fill: "#424242"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M3.8359 12.1441C3.8359 12.1441 4.84225 11.4111 4.65046 9.54119C4.45866 7.67131 2.7754 6.55859 2.7754 6.55859C2.38903 7.30077 2.12917 8.09906 2.00598 8.92229C1.77583 10.632 2.74833 12.0695 3.8359 12.1441Z",
    fill: "url(#paint14_linear_5253_12980)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_55",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86561 6.75809C2.86561 6.75809 4.52856 8.23513 4.40221 9.79556C4.27585 11.356 2.63546 11.0948 2.30603 10.1709C1.9766 9.24688 2.65577 6.72737 2.86561 6.75809Z",
    fill: "#F7F7F7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_56",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M2.87464 6.96875C2.87464 6.96875 2.32634 8.72451 2.68285 9.28855C3.03936 9.85259 3.98704 9.6419 4.10662 8.92203C4.22621 8.20217 2.87464 6.96875 2.87464 6.96875Z",
    fill: "#F7F7F7"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M10.0567 22.4661C10.0736 21.493 10.2543 20.5293 10.5915 19.613L10.6885 19.3672L10.9322 19.4857C11.0202 19.5296 13.1051 20.5831 13.6173 22.7426C14.1295 24.9022 13.0532 25.9754 13.0058 26.0193L12.9404 26.0808H12.8501C12.79 26.0841 12.7297 26.0841 12.6696 26.0808C11.4015 26.0237 10.0522 24.5555 10.0567 22.4661ZM13.1367 22.8458C12.7779 21.3227 11.5076 20.3877 10.957 20.0519C10.7023 20.8333 10.5655 21.6465 10.5509 22.4661C10.5509 24.2548 11.6791 25.5541 12.6922 25.6023H12.7238C12.9246 25.3675 13.5248 24.4852 13.1367 22.8458Z",
    fill: "#424242"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M12.8343 25.8466C12.8343 25.8466 13.87 24.8765 13.3781 22.7959C12.8862 20.7154 10.8306 19.6992 10.8306 19.6992C10.5051 20.5899 10.3306 21.526 10.3139 22.4711C10.2981 24.4288 11.6068 25.9168 12.8343 25.8466Z",
    fill: "url(#paint15_linear_5253_12980)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_59",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9548 19.9102C10.9548 19.9102 13.0464 21.3389 13.1344 23.1144C13.2224 24.8899 11.3293 24.8285 10.8284 23.8321C10.3275 22.8357 10.7133 19.9036 10.9548 19.9102Z",
    fill: "#F7F7F7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_60",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9931 20.1445C10.9931 20.1445 10.6366 22.19 11.1218 22.7782C11.6069 23.3664 12.6448 22.9976 12.6719 22.168C12.699 21.3384 10.9931 20.1445 10.9931 20.1445Z",
    fill: "#F7F7F7"
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M6.76917 17.8951C7.26757 17.0496 7.90562 16.2896 8.65776 15.6456L8.86535 15.4766L9.01878 15.696C9.07519 15.775 10.3726 17.6713 9.74985 19.8089C9.12708 21.9465 7.6469 22.3723 7.58372 22.3877L7.49572 22.4118L7.41449 22.3723C7.35997 22.348 7.3072 22.3201 7.25654 22.2889C6.18702 21.6415 5.73349 19.7211 6.76917 17.8951ZM9.27601 19.6772C9.72728 18.1739 9.06616 16.7539 8.75704 16.2052C8.15298 16.7713 7.63551 17.4188 7.22044 18.1278C6.31789 19.6904 6.66763 21.3606 7.53408 21.8807L7.56116 21.8961C7.84546 21.7819 8.79991 21.2881 9.28503 19.6772H9.27601Z",
    fill: "#424242"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M7.52956 22.1672C7.52956 22.1672 8.91724 21.805 9.52195 19.753C10.1267 17.701 8.82472 15.8398 8.82472 15.8398C8.09552 16.4698 7.47669 17.2111 6.99254 18.0345C6.01327 19.7223 6.41942 21.6426 7.52956 22.1672Z",
    fill: "url(#paint16_linear_5253_12980)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_63",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83602 16.0785C8.83602 16.0785 9.96421 18.3149 9.14965 19.9104C8.3351 21.506 6.72179 20.5689 6.77368 19.4518C6.82558 18.3346 8.62843 15.96 8.83602 16.0785Z",
    fill: "#F7F7F7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_64",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7548 16.3008C8.7548 16.3008 7.42354 17.9227 7.55215 18.6711C7.68076 19.4195 8.77736 19.5775 9.21285 18.8642C9.64833 18.1509 8.7548 16.3008 8.7548 16.3008Z",
    fill: "#F7F7F7"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M6.35401 8.86123C7.15287 8.4989 8.00729 8.26612 8.88342 8.1721L9.12259 8.15234V8.38498C9.12259 8.47058 9.06844 10.4809 7.50251 11.7078C5.93658 12.9346 4.6527 12.511 4.59855 12.4957L4.52409 12.4693L4.48347 12.4013C4.45865 12.3574 4.43609 12.3091 4.41352 12.263C3.97579 11.2644 4.65045 9.65791 6.35401 8.86123ZM7.22046 11.3786C8.32158 10.516 8.59234 9.17288 8.65552 8.6242C7.92489 8.73073 7.21369 8.93841 6.54355 9.24092C5.08593 9.92347 4.46317 11.2952 4.81516 12.094C4.81754 12.1026 4.82135 12.1108 4.82644 12.1182C5.09495 12.184 6.04263 12.3069 7.22046 11.3786Z",
    fill: "#424242"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M4.67299 12.2916C4.67299 12.2916 5.86662 12.7305 7.36486 11.5432C8.86309 10.3558 8.90145 8.38281 8.90145 8.38281C8.05127 8.47514 7.22215 8.70121 6.44651 9.0522C4.85125 9.7984 4.14274 11.3808 4.67299 12.2916Z",
    fill: "url(#paint17_linear_5253_12980)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_67",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77959 8.56076C8.77959 8.56076 8.42083 10.7225 7.01059 11.4731C5.60035 12.2237 4.92343 10.7555 5.53943 9.97854C6.15542 9.20161 8.69385 8.3786 8.77959 8.56076Z",
    fill: "#F7F7F7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_68",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60586 8.6875C8.60586 8.6875 6.80075 9.19887 6.50742 9.80021C6.21409 10.4016 6.91583 11.0578 7.60177 10.7593C8.28771 10.4608 8.60586 8.6875 8.60586 8.6875Z",
    fill: "#F7F7F7"
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M7.87934 3.71279C8.6782 3.35046 9.53262 3.11768 10.4087 3.02366L10.6479 3.00391V3.23654C10.6479 3.32214 10.5938 5.33248 9.0301 6.55932C7.46642 7.78616 6.18029 7.36697 6.12613 7.34722L6.05167 7.32088L6.01106 7.25285C5.98624 7.20895 5.96367 7.16287 5.94111 7.11458C5.50111 6.11599 6.17577 4.51167 7.87934 3.71279ZM8.75482 6.23012C9.85593 5.3676 10.1267 4.03542 10.1899 3.47577C9.45539 3.58127 8.74032 3.78897 8.06662 4.09248C6.609 4.77503 5.98624 6.14672 6.33823 6.94559C6.34156 6.95382 6.34533 6.96188 6.34951 6.96973C6.62028 7.03557 7.57022 7.15848 8.75482 6.23012Z",
    fill: "#424242"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M6.19833 7.14972C6.19833 7.14972 7.38519 7.5733 8.8902 6.39474C10.3952 5.21619 10.429 3.23438 10.429 3.23438C9.57887 3.32368 8.74911 3.54601 7.97185 3.89279C6.37659 4.64996 5.67034 6.23234 6.19833 7.14972Z",
    fill: "url(#paint18_linear_5253_12980)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_71",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3072 3.41802C10.3072 3.41802 9.94616 5.5798 8.53592 6.33039C7.12568 7.08098 6.44876 5.60394 7.06476 4.82702C7.68075 4.05009 10.2192 3.22928 10.3072 3.41802Z",
    fill: "#F7F7F7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_72",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1312 3.53906C10.1312 3.53906 8.32608 4.05043 8.03275 4.65178C7.73942 5.25312 8.44116 5.90934 9.1271 5.61086C9.81304 5.31238 10.1312 3.53906 10.1312 3.53906Z",
    fill: "#F7F7F7"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M5.57105 13.8594C6.27531 13.3464 7.06114 12.9491 7.89738 12.683L8.12302 12.6172L8.16815 12.8367C8.1862 12.9201 8.55624 14.8953 7.28139 16.4074C6.00653 17.9196 4.67301 17.7769 4.61886 17.7769H4.53763L4.48573 17.7177C4.45092 17.6794 4.41852 17.6391 4.38871 17.597C3.75015 16.6796 4.07281 14.9787 5.57105 13.8594ZM6.95873 16.1507C7.86128 15.0862 7.83646 13.7167 7.78682 13.1681C7.08933 13.4175 6.43209 13.7626 5.83505 14.193C4.55342 15.1433 4.23076 16.6181 4.73845 17.338C4.74496 17.3444 4.7503 17.3518 4.75424 17.3599C5.03855 17.3621 5.99299 17.2941 6.95873 16.1507Z",
    fill: "#424242"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M4.64819 17.5592C4.64819 17.5592 5.90048 17.7392 7.13021 16.2863C8.35994 14.8334 7.97184 12.8867 7.97184 12.8867C7.16145 13.1465 6.39951 13.5319 5.71546 14.028C4.29845 15.077 3.93969 16.767 4.64819 17.5592Z",
    fill: "url(#paint19_linear_5253_12980)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_75",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89738 13.0887C7.89738 13.0887 7.99892 15.2834 6.76919 16.293C5.53946 17.3025 4.57373 15.9945 5.01372 15.1144C5.45372 14.2343 7.762 12.9219 7.89738 13.0887Z",
    fill: "#F7F7F7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_76",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74164 13.2422C7.74164 13.2422 6.09223 14.1003 5.92074 14.7478C5.74926 15.3952 6.58186 15.8978 7.19334 15.4698C7.80482 15.0418 7.74164 13.2422 7.74164 13.2422Z",
    fill: "#F7F7F7"
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M38.9925 10.6645C39.956 8.41057 34.1616 7.85751 30.5469 7.85092C29.7053 6.34097 27.2639 2.11397 25.6348 0.946394C23.8297 -0.35287 20.594 4.73225 18.7054 7.85751C15.2261 7.78289 8.43888 8.23939 9.47681 10.6645C10.332 12.6705 13.2901 15.7014 15.0772 17.4176C13.9851 20.4288 12.1439 27.5374 14.9621 27.2762C17.5727 27.0348 22.4307 24.5087 24.2358 23.5255C26.0409 24.5087 30.8989 27.037 33.5095 27.2762C36.3323 27.5374 34.4888 20.4288 33.3967 17.4176C35.1793 15.7014 38.1329 12.6705 38.9925 10.6645Z",
    fill: "#B5B5B5"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M39.5296 9.2171C38.3473 7.49207 33.7149 7.16945 30.9847 7.13433C29.8091 5.05595 27.6565 1.50053 26.0703 0.365872C25.7587 0.14054 25.38 0.0203241 24.9917 0.0234988C22.9181 0.0234988 20.5467 3.43187 18.288 7.13653H17.9879C15.6977 7.13653 10.2305 7.33844 8.93984 9.22149C8.76656 9.47205 8.66265 9.76184 8.63814 10.0629C8.61363 10.3639 8.66936 10.666 8.79994 10.9399C9.62352 12.8866 12.1845 15.6278 14.2288 17.6118C13.5948 19.4861 11.8325 25.2253 13.2969 27.2422C13.4646 27.4809 13.6909 27.6752 13.9553 27.8074C14.2196 27.9396 14.5137 28.0056 14.8109 27.9994C14.8861 28.0038 14.9614 28.0038 15.0366 27.9994C17.5592 27.7667 21.8509 25.6379 24.2404 24.3583C26.6299 25.6379 30.9215 27.7667 33.4441 27.9994C33.5193 28.0038 33.5946 28.0038 33.6698 27.9994C33.967 28.0058 34.2612 27.9399 34.5256 27.8077C34.79 27.6754 35.0162 27.4811 35.1838 27.2422C36.6505 25.2274 34.886 19.4861 34.2519 17.6118C36.2827 15.6366 38.8572 12.8866 39.6875 10.9399C39.8164 10.6639 39.8695 10.3602 39.8418 10.0583C39.8141 9.75638 39.7066 9.46659 39.5296 9.2171ZM15.7676 17.6557L15.9233 17.2168L15.5917 16.9095C13.9106 15.292 10.9661 12.2897 10.1538 10.3913C10.1173 10.3351 10.0979 10.2701 10.0979 10.2036C10.0979 10.1372 10.1173 10.0721 10.1538 10.016C10.6479 9.29831 13.4932 8.56747 17.9789 8.56747C18.2181 8.56747 18.4527 8.56747 18.6806 8.56747H19.1116L19.3372 8.20535C22.7196 2.633 24.2787 1.45444 24.9917 1.45444C25.0665 1.45402 25.1391 1.47884 25.1971 1.52467C26.7246 2.62203 29.1818 6.90389 29.8971 8.19218L30.107 8.56747H30.5447C34.992 8.56747 37.8148 9.3027 38.3044 10.016C38.3417 10.0718 38.3615 10.137 38.3615 10.2036C38.3615 10.2702 38.3417 10.3354 38.3044 10.3913C37.4921 12.2963 34.5475 15.292 32.8665 16.9095L32.5348 17.2278L32.6905 17.6667C33.918 21.0531 34.7213 25.3789 33.9586 26.4258C33.9266 26.4769 33.8804 26.5183 33.8253 26.5451C33.7702 26.5719 33.7085 26.583 33.6472 26.5772H33.5705C31.0569 26.3358 26.0635 23.7021 24.5946 22.9011L24.2358 22.7057L23.8771 22.9011C22.4037 23.7021 17.4103 26.3358 14.8922 26.5552H14.8155C14.7539 26.5607 14.692 26.5495 14.6366 26.5227C14.5812 26.496 14.5346 26.4548 14.5018 26.4038C13.7392 25.3679 14.5424 21.0422 15.7676 17.6557Z",
    fill: "#424242"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M38.9925 10.6645C39.956 8.41057 34.1616 7.85751 30.5469 7.85092C29.7053 6.34097 27.2639 2.11397 25.6348 0.946394C23.8297 -0.35287 20.594 4.73225 18.7054 7.85751C15.2261 7.78289 8.43888 8.23939 9.47681 10.6645C10.332 12.6705 13.2901 15.7014 15.0772 17.4176C13.9851 20.4288 12.1439 27.5374 14.9621 27.2762C17.5727 27.0348 22.4307 24.5087 24.2358 23.5255C26.0409 24.5087 30.8989 27.037 33.5095 27.2762C36.3323 27.5374 34.4888 20.4288 33.3967 17.4176C35.1793 15.7014 38.1329 12.6705 38.9925 10.6645Z",
    fill: "url(#paint20_linear_5253_12980)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M36.6143 11.2026C37.4221 9.31294 32.5528 8.84985 29.5293 8.84327C28.823 7.57693 26.7765 4.03029 25.4069 3.05145C23.8861 1.9541 21.1807 6.22938 19.5967 8.84985C16.6769 8.77743 10.9841 9.17028 11.8528 11.2026C12.5703 12.8881 15.0523 15.4296 16.5506 16.8693C15.6345 19.3954 14.0889 25.3584 16.4536 25.1389C18.6445 24.9348 22.7195 22.8169 24.2336 21.9939C25.7498 22.8169 29.8249 24.9348 32.0136 25.1389C34.3805 25.3584 32.8326 19.3954 31.9188 16.8693C33.4148 15.4296 35.8968 12.8881 36.6143 11.2026Z",
    fill: "url(#paint21_linear_5253_12980)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.43
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M33.3945 15.8971C33.5163 16.2329 33.6472 16.6235 33.7803 17.0449C35.5854 15.2891 38.196 12.5348 38.9926 10.6671C39.0857 10.4786 39.1193 10.2676 39.0892 10.0606C39.0591 9.85352 38.9666 9.65982 38.8233 9.50391C37.7967 11.4989 35.0755 14.2818 33.3945 15.8971Z",
    fill: "#6E6E6E"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M15.0749 15.8954C13.3916 14.2779 10.6682 11.4928 9.64377 9.5C9.50044 9.65634 9.40806 9.85056 9.37833 10.058C9.3486 10.2655 9.38288 10.4769 9.4768 10.6654C10.2733 12.5331 12.8907 15.2874 14.689 17.0432C14.8222 16.6218 14.953 16.2399 15.0749 15.8954Z",
    fill: "#6E6E6E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_83",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5072 25.7525C30.8966 25.511 26.0409 22.9871 24.2335 22.0039C22.4284 22.9871 17.5704 25.5154 14.9598 25.7525C14.0414 25.8381 13.6195 25.1401 13.5022 24.0603C13.351 25.9478 13.6579 27.3963 14.9598 27.2756C17.5704 27.0342 22.4284 24.5081 24.2335 23.5248C26.0386 24.5081 30.8966 27.0364 33.5072 27.2756C34.8092 27.3963 35.116 25.9478 34.9649 24.0603C34.8475 25.1401 34.4256 25.8381 33.5072 25.7525Z",
    fill: "#6E6E6E"
  })))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M18.1775 24.2513C18.3264 24.1921 22.2389 22.5768 23.304 21.8854C24.369 21.1941 24.4006 21.328 27.4489 23.0684C30.4973 24.8088 32.061 25.0656 32.6115 24.6179C33.1621 24.1701 32.7943 25.3509 31.3412 25.0326C29.8881 24.7144 25.0098 22.5965 24.6217 22.2959C24.2336 21.9952 19.3756 24.9449 17.0425 25.0502C14.7094 25.1556 16.431 24.9361 18.1775 24.2513Z",
    fill: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_85",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5293 8.84327C28.823 7.57693 26.7765 4.03029 25.4069 3.05145C23.8861 1.9541 21.1807 6.22938 19.5967 8.84985C16.6769 8.77743 10.9841 9.17028 11.8528 11.2026C12.5703 12.8881 15.0523 15.4296 16.5506 16.8693C16.3249 17.5036 16.0497 18.3595 15.8105 19.2835C18.6016 19.6719 22.442 18.6514 25.2399 17.6462C29.9648 15.9497 31.542 15.5876 36.4789 11.5011C36.5286 11.4023 36.576 11.3057 36.6143 11.2114C37.4221 9.31294 32.5619 8.84985 29.5293 8.84327Z",
    fill: "#F7F7F7"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    opacity: 0.49,
    d: "M29.5293 8.84327C28.823 7.57693 26.7765 4.03029 25.4069 3.05145C23.8861 1.9541 21.1807 6.22938 19.5967 8.84985C16.6769 8.77743 10.9841 9.17028 11.8528 11.2026C11.8528 11.2179 11.8663 11.2311 11.8708 11.2465C12.62 9.91209 17.1124 9.64214 19.5967 9.69701C21.1762 7.07434 23.8838 2.80784 25.4069 3.89641C26.7765 4.87744 28.823 8.42189 29.5293 9.69042C32.0745 9.69042 35.9081 10.0218 36.5963 11.2465C36.6032 11.2322 36.6093 11.2176 36.6143 11.2026C37.4221 9.31294 32.5619 8.84985 29.5293 8.84327Z",
    fill: "#F7F7F7"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M24.8698 2.87922C24.1433 2.85288 22.3382 4.50549 21.0521 6.54656C19.7659 8.58764 23.7597 4.37381 24.8698 4.45282C25.98 4.53183 26.262 2.91653 24.8698 2.87922Z",
    fill: "#F7F7F7"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M25.7905 1.19581C25.7905 1.19581 25.6415 2.99986 25.2489 2.79795C25.1102 2.72911 24.9541 2.70018 24.799 2.71457C24.644 2.72895 24.4963 2.78604 24.3735 2.87915L23.9989 1.19581C23.9989 1.19581 24.9985 0.280623 25.7905 1.19581Z",
    fill: "#F7F7F7"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M10.0522 9.30469C10.5555 9.41059 11.0379 9.59514 11.4805 9.85117L12.013 10.2089C11.827 10.3819 11.7156 10.6173 11.7016 10.8673C11.7016 11.2404 11.7625 11.2755 11.7625 11.2755C11.7625 11.2755 9.58059 11.0912 9.39331 10.3976C9.20603 9.70412 9.80849 9.3837 10.0522 9.30469Z",
    fill: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_90",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.43
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2728 9.165C37.9176 9.30264 37.5768 9.47315 37.2551 9.67418C37.0296 9.80274 36.8405 9.98372 36.7046 10.2009C36.7501 10.3442 36.7826 10.491 36.8016 10.6398V11.0064C36.8016 11.0064 38.2096 10.8549 38.6406 10.6398C39.0715 10.4248 39.049 9.80586 38.9362 9.65442C38.8233 9.50299 38.4036 9.11233 38.2728 9.165Z",
    fill: "#6E6E6E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_91",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.43
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M15.894 25.1098C15.894 25.1098 15.2915 27.0302 15.1178 27.1531C14.944 27.276 14.2152 27.3725 13.9444 26.9051C13.6737 26.4376 13.5383 26.1172 13.6692 25.8363C13.8 25.5553 15.3908 24.6445 15.3908 24.6445C15.3908 24.6445 15.6074 25.1098 15.894 25.1098Z",
    fill: "#6E6E6E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_92",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.43
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4581 25.1098C32.4581 25.1098 33.0583 27.0302 33.2343 27.1531C33.4103 27.276 34.1368 27.3725 34.4053 26.9051C34.6738 26.4376 34.816 26.1106 34.6829 25.8363C34.5497 25.5619 32.9612 24.6445 32.9612 24.6445C32.9612 24.6445 32.7446 25.1098 32.4581 25.1098Z",
    fill: "#6E6E6E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_93",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.43
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3825 22.2969V23.5281C24.3825 23.5281 17.117 27.0835 16.1941 27.2591L15.2735 27.4303L16.1941 25.5275C16.1941 25.5275 23.568 22.9706 24.3825 22.2969Z",
    fill: "#6E6E6E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_94",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5967 8.8532L18.7054 7.8612C18.7054 7.8612 21.0024 3.66932 22.6992 2.19668C24.396 0.724031 25.2715 0.3641 25.2715 1.58216C25.2715 2.80022 24.8789 2.88142 24.8789 2.88142C24.8789 2.88142 22.9768 3.03505 19.5967 8.8532Z",
    fill: "#F7F7F7"
  }))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M23.6424 17.9126L24.8969 16.9009C26.6479 15.3646 27.8144 14.028 27.8144 12.4039C27.8144 10.5253 26.4606 9.35549 24.2493 9.35549C23.2262 9.35286 22.2183 9.59719 21.316 10.0666L21.0701 10.1961L21.4447 11.1178L21.756 10.9576C22.3513 10.6398 23.0176 10.4687 23.6965 10.4594C25.206 10.4594 26.1424 11.2912 26.1424 12.6278V12.6453C26.0996 14.2738 24.5314 15.7552 22.1441 17.8336L20.8129 19.0034V19.8681H28.0333V18.7005H23.6424V17.9126ZM26.7833 12.6453V12.6212C26.8072 12.0332 26.628 11.4544 26.2742 10.9771C25.9204 10.4997 25.4125 10.1514 24.8315 9.98756C26.3387 10.1544 27.1894 11.0103 27.1894 12.3886C27.1894 13.5057 26.4967 14.513 25.3843 15.5972C26.2507 14.6052 26.7562 13.6703 26.7833 12.6432V12.6453ZM23.0151 19.2404H21.4808L22.5638 18.277C22.7127 18.1497 22.8571 18.0224 22.9993 17.8973L23.0151 19.2404Z",
    fill: "#424242"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M29.5112 12.3895C29.5112 9.58468 27.4015 7.69943 24.2584 7.69943C22.6397 7.68751 21.0591 8.17716 19.7456 9.09746L19.0326 9.61321L20.691 13.7063L21.9117 12.7977C22.5458 12.3259 23.1482 12.0866 23.7033 12.0866C24.4524 12.0866 24.4592 12.3698 24.4614 12.6002C24.4253 13.4781 23.225 14.6808 21.0205 16.5968L19.1319 18.2603V21.5085H29.7369V17.0554H27.1691C28.3537 15.8703 29.5112 14.3252 29.5112 12.3895ZM29.0938 17.6722V20.8808H19.7637V18.5347L21.4356 17.0554C23.877 14.931 25.0459 13.7239 25.0865 12.6156C25.0865 11.8738 24.5991 11.4831 23.6943 11.4831C22.9971 11.4831 22.266 11.764 21.5191 12.3193L20.9844 12.7297L19.8088 9.83268L20.1292 9.59785C21.335 8.75594 22.7854 8.31002 24.2697 8.32492C27.0337 8.32492 28.8907 9.96217 28.8907 12.3983C28.8907 14.402 27.4466 15.991 26.1831 17.1498L25.6077 17.6809L29.0938 17.6722Z",
    fill: "#424242"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M29.3488 21.1895H19.3846V18.4L21.1694 16.8286C23.4935 14.8073 24.6803 13.598 24.7164 12.606C24.7164 12.2197 24.5833 11.7808 23.6402 11.7808C23.0151 11.7808 22.3382 12.042 21.6613 12.5555L20.7745 13.2139L19.353 9.71998L19.8562 9.34469C21.1166 8.46239 22.6334 7.99417 24.1862 8.00812C27.1398 8.00812 29.1232 9.76388 29.1232 12.3975C29.1232 14.3903 27.8415 15.9727 26.3252 17.3729H29.3398L29.3488 21.1895ZM21.0746 19.5479H27.6588V19.008H23.2611V17.7789L24.6307 16.6684C26.3207 15.2002 27.4444 13.9097 27.4444 12.4019C27.4444 10.6857 26.2305 9.66292 24.1952 9.66292C23.2259 9.65499 22.2696 9.87962 21.4108 10.3169L21.553 10.6659C22.1931 10.3241 22.91 10.1409 23.6402 10.1326C25.3189 10.1326 26.4042 11.1048 26.4042 12.6126V12.6324C26.3568 14.3881 24.748 15.9112 22.2999 18.0423L21.0746 19.1287V19.5479Z",
    fill: "url(#paint22_linear_5253_12980)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_98",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3689 8.00781C23.0328 8.01355 21.7175 8.33037 20.5331 8.93178L19.3688 9.71968L20.3887 9.99841C20.3887 9.99841 22.09 8.91422 23.7732 8.86375C25.4565 8.81327 27.6587 10.0445 27.6587 10.0445L28.4304 9.71749C27.7151 8.74084 26.3794 8.00781 24.3689 8.00781Z",
    fill: "#F7F7F7"
  }))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M20.2285 20.3689V18.7646L21.738 17.4478C24.2855 15.2312 25.5242 13.956 25.5603 12.6304C25.5603 11.7043 24.985 10.9712 23.6402 10.9712C22.6338 10.9712 21.7561 11.4607 21.1446 11.9128L20.3729 10.01C21.4874 9.23596 22.8259 8.82634 24.1952 8.84018C26.8352 8.84018 28.2883 10.3414 28.2883 12.4022C28.2883 14.305 26.8713 15.8237 25.1835 17.2898L24.1072 18.1677V18.2028H28.5027V20.3689H20.2285Z",
    fill: "url(#paint23_linear_5253_12980)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M28.2861 12.5083C28.2861 12.4644 28.2861 12.4205 28.2861 12.3766C28.2861 10.318 26.8329 8.8168 24.193 8.8168C22.8235 8.80189 21.4847 9.21161 20.3707 9.98657L20.4542 10.1929C21.554 9.45887 22.8592 9.07121 24.193 9.08236C26.7765 9.08455 28.2229 10.5199 28.2861 12.5083Z",
    fill: "#F7F7F7"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M24.1072 18.4084V18.4435H28.5026V18.1758H24.3915L24.1072 18.4084Z",
    fill: "#F7F7F7"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M25.5603 12.8746C25.5603 12.8219 25.5603 12.7692 25.5603 12.7188C25.461 14.0048 24.2223 15.269 21.7447 17.4242L20.2352 18.741V19.0088L21.7447 17.6919C24.2854 15.4753 25.5242 14.2002 25.5603 12.8746Z",
    fill: "#F7F7F7"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    opacity: 0.46,
    d: "M21.2213 11.947L20.77 13.2133C20.77 13.2133 22.5435 11.868 23.665 11.9535C24.7864 12.0391 24.6375 12.3925 24.6375 12.3925L25.4182 11.8899C25.4182 11.8899 24.9308 10.865 23.4935 10.9637C22.6403 11.0194 21.8351 11.3678 21.2213 11.947Z",
    fill: "#424242"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    opacity: 0.46,
    d: "M20.2285 20.3672L19.3846 21.188H29.3488L28.5026 20.3672H20.2285Z",
    fill: "#424242"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_105",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3488 17.3633L28.5026 18.1753L24.1072 18.1841L26.3342 17.3633H29.3488Z",
    fill: "#F7F7F7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_106",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3846 18.3986L20.2285 18.7541C20.2285 18.7541 23.8387 15.642 24.4298 14.8805L25.0143 14.1211H23.9763C23.9763 14.1211 21.6161 16.5682 19.3846 18.3986Z",
    fill: "#F7F7F7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_107",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1997 8.82844C22.8304 8.81505 21.4921 9.22463 20.3774 9.99822L21.1491 11.901C21.7605 11.4489 22.6383 10.9595 23.6446 10.9595C24.9985 10.9595 25.5648 11.6925 25.5648 12.6187C25.5648 13.5449 24.9037 14.4798 23.6198 15.7308C23.7123 15.7308 23.8048 15.7308 23.8973 15.7308C25.8717 15.7308 27.5662 14.3415 28.2928 12.3619C28.2837 10.3165 26.8306 8.82844 24.1997 8.82844Z",
    fill: "#F7F7F7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    style: {
      mixBlendMode: "overlay"
    },
    d: "M23.6763 0.878906C22.2051 0.878906 21.0137 1.9587 21.0137 3.29308C21.0137 4.62746 22.2051 5.70725 23.6763 5.70725C25.1474 5.70725 26.341 4.62746 26.341 3.29308C26.341 1.9587 25.1474 0.878906 23.6763 0.878906Z",
    fill: "url(#paint24_radial_5253_12980)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    opacity: 0.7,
    d: "M21.2438 6.47015C21.9591 5.69103 24.0598 3.29222 24.0598 3.29222C24.0598 3.29222 25.8175 0.0879582 25.8649 0.000170156C25.8649 -0.0261663 23.6085 3.01349 23.6085 3.01349L21.2438 6.47015Z",
    fill: "#F7F7F7"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M24.2561 2.72245C23.6085 2.23083 23.7259 0.843782 23.7191 0.453125V0.828419C23.7191 0.766967 23.7191 0.703321 23.7191 0.690153V0.453125C23.7191 0.565055 23.7191 0.742826 23.683 0.949127C23.683 0.949127 23.4935 2.33837 23.1505 2.62588C22.3788 3.28429 20.4428 3.157 21.1807 3.17455C23.692 3.22723 23.692 5.61506 23.7168 6.39857V6.00352C23.7168 6.03206 23.7168 6.0562 23.7168 6.06937V6.39857C23.771 4.54405 23.7642 3.36988 25.9597 3.21406C26.6885 3.15919 25.0143 3.29307 24.2561 2.72245Z",
    fill: "#F7F7F7"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5253_12980",
    x1: 38.8651,
    y1: 10.9529,
    x2: 37.4336,
    y2: 25.9731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECEDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6C79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5253_12980",
    x1: 41.0353,
    y1: 24.2522,
    x2: 37.5892,
    y2: 27.2621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECEDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6C79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5253_12980",
    x1: 46.5132,
    y1: 18.0985,
    x2: 43.8017,
    y2: 21.7339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECEDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6C79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5253_12980",
    x1: 46.2563,
    y1: 12.9582,
    x2: 45.6414,
    y2: 16.8764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECEDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6C79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5253_12980",
    x1: 43.9893,
    y1: 7.48959,
    x2: 45.1341,
    y2: 11.2962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECEDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6C79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5253_12980",
    x1: 35.6551,
    y1: 20.5856,
    x2: 36.4101,
    y2: 25.0288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECEDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6C79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5253_12980",
    x1: 36.7357,
    y1: 16.1314,
    x2: 39.5625,
    y2: 19.7096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECEDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6C79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5253_12980",
    x1: 36.7521,
    y1: 10.7811,
    x2: 40.6526,
    y2: 11.9195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECEDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6C79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5253_12980",
    x1: 35.2131,
    y1: 5.64161,
    x2: 39.1136,
    y2: 6.77997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECEDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6C79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5253_12980",
    x1: 39.8883,
    y1: 14.4128,
    x2: 43.4507,
    y2: 16.3438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECEDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6C79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5253_12980",
    x1: 7.47734,
    y1: 8.93114,
    x2: 8.88695,
    y2: 23.9723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECEDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6C79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5253_12980",
    x1: 4.51405,
    y1: 25.9014,
    x2: 7.97386,
    y2: 28.9238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECEDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6C79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5253_12980",
    x1: 5.26132,
    y1: 18.6961,
    x2: 7.97441,
    y2: 22.3331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECEDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6C79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5253_12980",
    x1: 1.68981,
    y1: 12.391,
    x2: 2.30271,
    y2: 16.3096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECEDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6C79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_5253_12980",
    x1: 10.7934,
    y1: 13.0214,
    x2: 9.66928,
    y2: 16.8095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECEDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6C79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_5253_12980",
    x1: 10.6752,
    y1: 18.5831,
    x2: 9.91227,
    y2: 23.0308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECEDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6C79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_5253_12980",
    x1: 9.09526,
    y1: 11.0395,
    x2: 6.27038,
    y2: 14.6188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECEDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6C79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_5253_12980",
    x1: 12.2491,
    y1: 7.21078,
    x2: 8.34861,
    y2: 8.34913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECEDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6C79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_5253_12980",
    x1: 13.7902,
    y1: 2.06919,
    x2: 9.88766,
    y2: 3.20844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECEDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6C79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_5253_12980",
    x1: 11.4741,
    y1: 12.857,
    x2: 7.91236,
    y2: 14.7782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECEDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6C79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_5253_12980",
    x1: 9.36851,
    y1: 14.0093,
    x2: 39.0986,
    y2: 14.0093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECEDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6C79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_5253_12980",
    x1: 11.7625,
    y1: 14.0118,
    x2: 36.7046,
    y2: 14.0118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECEDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6C79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_5253_12980",
    x1: 24.3509,
    y1: 21.8303,
    x2: 24.3509,
    y2: 4.57999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECEDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6C79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_5253_12980",
    x1: 24.3667,
    y1: 9.37569,
    x2: 24.3667,
    y2: 22.0633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECEDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6C79"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_5253_12980",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.6763 3.29527) scale(2.57453 2.50415)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5253_12980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyAsset41);
export default __webpack_public_path__ + "static/media/happyAsset 4 1.9c8492a2846ff3a848b3a48ca2b1efb1.svg";
export { ForwardRef as ReactComponent };